import { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';
import { passiveDomainTarget } from '../lib/domainRedirect';

/**
 * Pasif yapılmış bir domaine gelen ziyaretçiyi ana domaine taşır
 * (Alan Adları → "Pasif domainden ana domaine yönlendir").
 *
 * Bu, sunucu tarafındaki DNS/nginx değişikliğinin yerine geçmez: ziyaretçi
 * pasif domaine hâlâ ulaşabiliyorsa (alternatif DNS, VPN) onu yeni adrese
 * götürür. Panel yolları ve kayıtlı olmayan adresler (localhost, panel
 * domaini) hiç yönlendirilmez.
 */
const DomainRedirect = () => {
  const settings = useSettings();
  const domains = settings.site_domains;
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const target = passiveDomainTarget(domains, window.location);
    if (target) window.location.replace(target);
  }, [domains]);
  return null;
};

export default DomainRedirect;
